<template>
  <div>
    <nav aria-label='breadcrumb'>
      <ol class='breadcrumb'>
        <li class='breadcrumb-item'>
          <a href='#'>{{translations('navbar.inventory_control')}}</a>
        </li>
        <li class='breadcrumb-item'>
          <router-link to='/archive-discard'>{{translations('discard.archive_discard')}}</router-link>
        </li>
        <li class='breadcrumb-item active' aria-current='page'>{{translations('discard.discard_registration')}}</li>
      </ol>
    </nav>
    <div class='container-fluid main-container'>
      <div class='d-flex flex-wrap'>
        <div class='left-container'>
          <h5 class='mb-3'>Information</h5>
          <table class='table table-sm table-borderless table-information'>
            <tbody>
              <tr>
                <th>{{translations('discard.application_date')}}</th>
                <td>
                  <button
                    ref='info01'
                    type='button'
                    class='btn btn-link p-0'
                    data-toggle='popover-x'
                    data-target='#popover-info01'
                    data-placement='right'
                  >{{ $invoiceTools.formatDateHours(discardInfo.apply_date) || '----------'}}</button>
                  <div id='popover-info01' class='popover popover-x popover-default'>
                    <div class='arrow'></div>
                    <div class='popover-header popover-title'>
                      <button class='close' data-dismiss='popover-x'>&times;</button>{{translations('discard.application_date')}}
                    </div>
                    <div class='popover-body d-flex'>
                      <input type='date' v-model='date_apply' class='form-control input-date'>
                      <input type='time' v-model='time_apply' class='form-control input-time'>
                    </div>
                    <div class='popover-footer'>
                      <button
                        @click="updateField('apply_date', `${date_apply} ${time_apply}`,'info01')"
                        type='submit'
                        class='btn btn-sm btn-primary'
                      >{{translations('common.update')}}</button>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th>{{translations('discard.disposal_date')}}</th>
                <td>
                  <button
                    ref='info02'
                    type='button'
                    class='btn btn-link p-0'
                    data-toggle='popover-x'
                    data-target='#popover-info02'
                    data-placement='right'
                  >{{ $invoiceTools.formatDateAt(discardInfo.discard_date) || '----------' }}</button>
                  <div id='popover-info02' class='popover popover-x popover-default'>
                    <div class='arrow'></div>
                    <div class='popover-header popover-title'>
                      <button class='close' data-dismiss='popover-x'>&times;</button>{{translations('discard.disposal_date')}}
                    </div>
                    <div class='popover-body d-flex'>
                      <input type='date' v-model='date_discard' class='form-control input-date'>
                      <input type='time' v-model='time_discard' class='form-control input-time'>
                    </div>
                    <div class='popover-footer'>
                      <button
                        @click="updateField('discard_date', `${date_discard} ${time_discard}`,'info02')"
                        type='submit'
                        class='btn btn-sm btn-primary'
                      >{{translations('common.update')}}</button>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th>{{translations('discard.division')}}</th>
                <td>
                  <button
                    ref='info03'
                    type='button'
                    class='btn btn-link p-0'
                    data-toggle='popover-x'
                    data-target='#popover-info03'
                    data-placement='right'
                  >
                    {{ translations(`discard.${tempInfo.division_type}`) || '----------' }}
                  </button>
                  <div id='popover-info03' class='popover popover-x popover-default'>
                    <div class='arrow'></div>
                    <div class='popover-header popover-title'>
                      <button class='close' data-dismiss='popover-x'>&times;</button>{{translations('discard.division')}}
                    </div>
                    <div class='popover-body popover-content'>
                      <select
                        class='form-control'
                        v-model="tempInfo.division_type_select">
                        <option
                          v-for="type in translatedDivisionTypes"
                          :key="type.value"
                          :value="type.value"
                        >
                          {{ type.label }}
                        </option>
                      </select>
                    </div>
                    <div class='popover-footer'>
                      <button type='submit' class='btn btn-sm btn-primary' @click="updateField('division_type', tempInfo.division_type_select, 'info03')">{{translations('common.update')}}</button>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th>{{translations('discard.organization_number')}}</th>
                <td>
                  <button
                    ref='info04'
                    type='button'
                    class='btn btn-link p-0'
                    data-toggle='popover-x'
                    data-target='#popover-info04'
                    data-placement='right'
                  >{{ discardInfo.discard_number || '----------'}}</button>
                  <div id='popover-info04' class='popover popover-x popover-default'>
                    <div class='arrow'></div>
                    <div class='popover-header popover-title'>
                      <button class='close' data-dismiss='popover-x'>&times;</button>{{translations('discard.organization_number')}}
                    </div>
                    <div class='popover-body popover-content'>
                      <input ref='input-info04' type='text' v-model='tempInfo.discard_number' class='form-control'>
                    </div>
                    <div class='popover-footer'>
                      <button
                        @click="updateField('discard_number',tempInfo.discard_number,'info04')"
                        type='submit'
                        class='btn btn-sm btn-primary'
                      >{{translations('common.update')}}</button>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th>{{translations('discard.applicant')}}</th>
                <td>
                  <button
                    ref='info05'
                    type='button'
                    class='btn btn-link p-0'
                    data-toggle='popover-x'
                    data-target='#popover-info05'
                    data-placement='right'
                  >{{ discardInfo.requester || '----------' }}</button>
                  <div id='popover-info05' class='popover popover-x popover-default popover-fit-content'>
                    <div class='arrow'></div>
                    <div class='popover-header popover-title'>
                      <button class='close' data-dismiss='popover-x'>&times;</button>{{translations('discard.applicant')}}
                    </div>
                    <div class='popover-body popover-content'>
                      <v-select :options="master_personnel" label="name" value="id" v-model="tempInfo.requester_id"></v-select>
                    </div>
                    <div class='popover-footer'>
                      <button
                        @click="updateField('requester_id',tempInfo.requester_id,'info05')"
                        type='submit'
                        class='btn btn-sm btn-primary'
                      >{{translations('common.update')}}</button>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th>{{translations('discard.manufacturer')}}</th>
                <td>
                  <button
                    ref='info06'
                    type='button'
                    class='btn btn-link p-0'
                    data-toggle='popover-x'
                    data-target='#popover-info06'
                    data-placement='right'
                  >{{ discardInfo.manufacturer || '----------'}}</button>
                  <div id='popover-info06' class='popover popover-x popover-default popover-fit-content'>
                    <div class='arrow'></div>
                    <div class='popover-header popover-title'>
                      <button class='close' data-dismiss='popover-x'>&times;</button>{{translations('discard.manufacturer')}}
                    </div>
                    <div class='popover-body popover-content'>
                      <v-select :options="master_partners" label="name" value="id" v-model="tempInfo.manufacturers_id"></v-select>
                    </div>
                    <div class='popover-footer'>
                      <button
                        @click="updateField('manufacturers_id',tempInfo.manufacturers_id,'info06')"
                        type='submit'
                        class='btn btn-sm btn-primary'
                      >{{translations('common.update')}}</button>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th>{{translations('discard.warehouse')}}</th>
                <td>
                  <button
                    ref='info07'
                    type='button'
                    class='btn btn-link p-0'
                    data-toggle='popover-x'
                    data-target='#popover-info07'
                    data-placement='right'
                  >{{ discardInfo.warehouse || '----------'}}</button>
                  <div id='popover-info07' class='popover popover-x popover-default popover-fit-content'>
                    <div class='arrow'></div>
                    <div class='popover-header popover-title'>
                      <button class='close' data-dismiss='popover-x'>&times;</button>{{translations('discard.warehouse')}}
                    </div>
                    <div class='popover-body popover-content'>
                      <v-select :options="master_mywarehouses" label="name" value="id" v-model="tempInfo.warehouses_id"></v-select>
                    </div>
                    <div class='popover-footer'>
                      <button
                        @click="updateField('warehouses_id',tempInfo.warehouses_id,'info07')"
                        type='submit'
                        class='btn btn-sm btn-primary'
                      >{{translations('common.update')}}</button>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th>{{translations('discard.reason')}}</th>
                <td>
                  <button
                    ref='info08'
                    type='button'
                    class='btn btn-link p-0'
                    data-toggle='popover-x'
                    data-target='#popover-info08'
                    data-placement='right'
                  >{{ discardInfo.reason  || '----------' }}</button>
                  <div id='popover-info08' class='popover popover-x popover-default'>
                    <div class='arrow'></div>
                    <div class='popover-header popover-title'>
                      <button class='close' data-dismiss='popover-x'>&times;</button>{{translations('discard.reason')}}
                    </div>
                    <div class='popover-body popover-content'>
                      <select
                        class='form-control'
                        v-model="tempInfo.reason">
                        <option
                          v-for="type in reasons"
                          :key="type.key"
                          :value="type.value"
                        >
                          {{type.value}}
                        </option>
                      </select>
                    </div>
                    <div class='popover-footer'>
                      <button type='submit' class='btn btn-sm btn-primary'
                              @click="updateField('reason', tempInfo.reason, 'info08')">
                        {{translations('common.update')}}
                      </button>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th>{{translations('discard.remarks')}}</th>
                <td>
                  <button
                    ref='info09'
                    type='button'
                    class='btn btn-link p-0'
                    data-toggle='popover-x'
                    data-target='#popover-info09'
                    data-placement='right'
                  >{{ discardInfo.memo || '----------' }}</button>
                  <div id='popover-info09' class='popover popover-x popover-default'>
                    <div class='arrow'></div>
                    <div class='popover-header popover-title'>
                      <button class='close' data-dismiss='popover-x'>&times;</button>{{translations('discard.remarks')}}
                    </div>
                    <div class='popover-body popover-content'>
                      <input type='text' v-model="tempInfo.memo" class='form-control'>
                    </div>
                    <div class='popover-footer'>
                      <button type='submit' class='btn btn-sm btn-primary' @click="updateField('memo', tempInfo.memo, 'info09')">{{translations('common.update')}}</button>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class='right-container'>
          <div class='table-scroll mb-4'>
            <table class='table table-sm table-striped table-1500 table-align-middle'>
              <thead>
                <tr>
                  <th></th>
                  <th>{{translations('discard.commodity_condition')}}</th>
                  <th>{{translations('discard.jan_code')}}</th>
                  <th>{{translations('discard.model')}}</th>
                  <th>{{translations('discard.tax_classification')}}</th>
                  <th>{{translations('discard.quantity')}}</th>
                  <th class="width-50-px">{{translations('discard.unit_price')}}</th>
                  <th>{{translations('discard.product_cost')}}</th>
                  <th>No.</th>
                  <th>{{translations('discard.summary')}}</th>
                  <th>{{translations('discard.unit_price_total')}}</th>
                  <th>{{translations('discard.total_cost')}}</th>
                  <th>{{translations('discard.total_profit')}}</th>
                </tr>
              </thead>
              <tbody class="nowrap">
                <template v-for='(detail, i) in discardDetail'>
                  <tr :key='i'>
                    <td>
                      <button @click="deleteDetail(i)" class='btn-change minus'><i></i></button>
                    </td>
                    <td>{{ translatedConditions[i] }}</td>
                    <td>{{ detail.jan_code }}</td>
                    <td>{{ detail.model }}</td>
                    <td>
                      <select
                       :disabled="false"
                        v-model="detail.taxclass_id"
                        v-validate="'required'"
                        data-vv-name="taxclass_id"
                        data-vv-as="税区分"
                        class="custom-select width-100-px"
                        required
                        @change="onchangeTaxclass"
                      >
                        <option value="1">{{translations('discard.taxable_item')}}</option>
                        <option value="2">{{translations('discard.not_applicable')}}</option>
                      </select>
                    </td><!-- TAXSTATUS -->
                    <!-- <td class="right" v-if="taxIncluded" colspan="2">{{ toTaxFormat(detail, 'unit_price') }}</td> -->
                    <td class="right">{{ detail.quantity.toLocaleString() }}</td>
                    <td class="right">{{ toTaxFormat(detail, 'unit_price') }}</td>
                    <td class="right">{{ toTaxFormat(detail, 'row_price') }}</td>
                    <td class="right"><input type="text" class="form-control form-control-sm" style="width:10em;" v-model="detail.client_order_number"/></td>
                    <td class="right"><input type="text" class="form-control form-control-sm" style="width:10em;" v-model="detail.remarks"/></td>
                    <td class="right">{{ toTaxFormat(detail, 'total_unit_price') }}</td>
                    <td class="right">{{ toTaxFormat(detail, 'total_cost') }}</td>
                    <td class="right">{{ toTaxFormat(detail, 'total_profit') }}</td>
                  </tr>
                </template>
                <tr class='bg-lightgreen'>
                  <td>
                    <button @click="openAddDetailModal()" class='btn-change plus' type='button'><i></i></button>
                    <button ref="openAddDetailModal" hidden="true" class='btn-change plus' type='button' data-toggle='modal' data-target='#NewDiscardsModal'><i></i></button>
                  </td>
                  <td></td>
                  <td></td><!-- TAXSTATUS -->
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td class='font-weight-bold right'>{{ displayGrandTotal(grandTotalUnitPrice, grandTotalUnitPriceIncTax) }}</td>
                  <td class='font-weight-bold right'>{{ displayGrandTotal(grandTotalCost, grandTotalCostIncTax) }}</td>
                  <td class='font-weight-bold right'>{{ displayGrandTotal(grandTotalProfit, grandTotalProfitIncTax) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class='form-inline'>
            <div class='form-group mr-2'>
              <button @click="addDiscard()" class='btn btn-sm btn-primary'>{{ translations('common.update') }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <NewDiscardsModal
      :discardDetails='discardDetail'
      :partnerId="tempInfo.manufacturers_id"
      :warehouseId="tempInfo.warehouses_id"
      :applyDate="discardInfo.apply_date"
      :divisionType="tempInfo.division_type_select"
    />
    <vue-element-loading :active="isLoading" :is-full-screen="true"/>
  </div>
</template>

<script>
import $ from 'jquery'
import { format } from 'date-fns'
import VueElementLoading from 'vue-element-loading'
import NewDiscardsModal from '@/components/NewDiscardsModal'
import { mapState } from 'vuex'
export default {
  name: 'NewDiscard',
  props: {},
  components: {
    VueElementLoading,
    NewDiscardsModal
  },
  watch: {
    discardDetail: {
      handler (v) {
        v.forEach((d, i) => {
          if (typeof d !== 'undefined') {
            v[i] = this.prepareDetails(d)
          }
        })
        this.calcGrandTotals()
      },
      deep: true
    }
  },
  data () {
    return {
      taxIncluded: false, // VAT
      isLoading: false,
      discardInfo: {},
      discardDetail: [],
      tempInfo: {},
      tempDetail: [],
      manufacturers: [],
      grandTotalUnitPrice: 0,
      grandTotalUnitPriceIncTax: 0,
      grandTotalCost: 0,
      grandTotalCostIncTax: 0,
      grandTotalProfit: 0,
      grandTotalProfitIncTax: 0,
      date_apply: format(new Date(), 'yyyy-MM-dd'),
      time_apply: format(new Date(), 'HH:mm'),
      date_discard: format(new Date(), 'yyyy-MM-dd'),
      time_discard: format(new Date(), 'HH:mm'),
      reasons: [
        { key: 1, value: '相殺' },
        { key: 2, value: '廃棄' },
        { key: 3, value: 'その他' }
      ],
      divisionTypes: [
        { value: 'F', label: '廃棄' },
        { value: 'G', label: '追加' }
      ]
    }
  },
  computed: {
    ...mapState(['currentLanguage']),
    master_mywarehouses () {
      return this.$store.getters['Master/getMywarehouses']
    },
    master_personnel () {
      return this.$store.getters['Master/getPersonnel']
    },
    master_partners () {
      return this.$store.getters['Master/getPartners']
    },
    translatedConditions () {
      return this.discardDetail.map(detail => {
        if (detail.is_bad) {
          return this.translations('discard.bad')
        } else if (detail.is_outlet) {
          return this.translations('discard.outlet')
        } else {
          return this.translations('discard.good')
        }
      })
    },
    translatedDivisionTypes () {
      return this.divisionTypes.map(divisionType => {
        return {
          value: divisionType.value,
          label: this.translations(`discard.${divisionType.label}`)
        }
      })
    }
  },
  created () {
    this.$store.dispatch('Master/checkMywarehouses')
    this.$store.dispatch('Master/checkPersonnel')
    this.$store.dispatch('Master/checkPartners')

    this.setEmptyData()
    this.tempInfo.division_type_select = 'F'
    this.tempInfo.division_type = '廃棄'
    this.discardInfo['division_type'] = 'F'
    this.tempInfo.reason = '相殺'

    this.isLoading = true
    Promise.all([
      this.getSequence()
    ]).finally(() => {
      this.isLoading = false
      this.setDiscardDate()
      this.popoverButtons()
    })
  },
  methods: {
    translations (key) {
      const language = require(`@/locales/${this.currentLanguage}.json`)
      const keys = key.split('.')
      let value = language

      for (const k of keys) {
        value = value[k]
        if (!value) break
      }

      return value || key
    },
    refresh (id) { // number-container
      var element = document.querySelectorAll("[id='" + id + "']")
      for (var i = 0; i < element.length; i++) {
        let $this = $(element[i])
        $this.val(Number($this.val())) // TO NUMBER
        $this.next().text((+$this.val()).toLocaleString()) // REFRESH
      }
    },
    numbers (index, target) {
      this.discardDetail[index][target] = this.discardDetail[index][target].toString().replace(/[^0-9.-]/g, '')
    },

    toTaxFormat (data, key) {
      const price = data[key] || 0

      let taxIncluded = true
      if (data.taxclass_id && Number(data.taxclass_id) === 2) { // 税区分（1:課税対象, 2:対象外）
        if (key === 'unit_price') {
          data.unit_price = price
          data.unit_price_inctax = price
        }
        taxIncluded = false
        return Number(price).toLocaleString()
      }

      const taxRate = Number(data.tax_rate || this.taxRate)
      const inctax = this.$util.getIncludeTax(price, taxRate)
      if (key === 'unit_price') {
        data.unit_price = price
        data.unit_price_inctax = inctax
        if (taxIncluded) {
          return `${Number(inctax).toLocaleString()} (${Number(price).toLocaleString()})`
        } else {
          return `${Number(price).toLocaleString()} (${Number(inctax).toLocaleString()})`
        }
      } else {
        if (!taxIncluded) { // 税込以外
          return `${Number(price).toLocaleString()} (${Number(inctax).toLocaleString()})`
        } else {
          return `${Number(inctax).toLocaleString()} (${Number(price).toLocaleString()})`
        }
      }
    },

    openAddDetailModal () {
      if (!this.tempInfo.manufacturers_id) {
        this.$toastr.warning(this.translations('discard.warning_choose_manufacturer'))
      } else if (!this.tempInfo.warehouses_id) {
        this.$toastr.warning(this.translations('discard.warning_choose_warehouse'))
      } else {
        this.$refs.openAddDetailModal.click()
      }
    },

    setEmptyData () {
      this.discardInfo = {}
      this.discardDetail = []
      this.tempInfo = {}
      this.tempDetail = []
      this.warehouses = []
      this.requester = []
    },

    isNewReturn () {
      return this.$route.name === 'new-discard'
    },

    setDiscardDate () {
      this.discardInfo.apply_date = format(new Date(), "yyyy-MM-dd'T'HH:mm")
      this.tempInfo.apply_date = format(new Date(), "yyyy-MM-dd'T'HH:mm")
    },

    popoverButtons () {
      window.$("button[data-toggle='popover-x']").each(function () {
        let targetID = window.$(this).attr('data-target')
        window.$(this).popoverButton({
          target: targetID,
          trigger: 'click'
        })
      })
    },

    /**
     * @param field : sales information props
     * @param value : value
     * @param ref   : reference trigger
     */
    updateField (field, value, ref, propToUpdate) {
      let $this = this
      let val = ''
      if (field === 'apply_date' || field === 'discard_date') {
        this.$refs[ref].innerText = format(new Date(value), 'yyyy/MM/dd HH:mm')
        val = format(new Date(value), "yyyy-MM-dd'T'HH:mm")
      } else if (field === 'warehouses_id') {
        this.master_mywarehouses.forEach(v => {
          if (v.id === parseInt(value.id)) {
            $this.$refs[ref].innerText = v.name
            val = v.id
          }
        })
      } else if (field === 'requester_id') {
        this.master_personnel.forEach(v => {
          if (v.id === parseInt(value.id)) {
            $this.$refs[ref].innerText = v.name
            val = v.id
          }
        })
      } else if (field === 'manufacturers_id') {
        val = 0 // DEFAULT // WARNING: DBがint型のため''ではエラーが発生する場合、該当selectのデフォルト値に0をセットし、比較対象が0件でも0になるよう初期値に0をセット
        this.master_partners.forEach(function (v) {
          if (v.id === parseInt(value.id)) {
            $this.$refs[ref].innerText = v.name
            val = v.id
          }
        })
      } else if (field === 'division_type') {
        this.discardInfo[field] = value
        this.tempInfo.division_type = this.divisionRenderText(value)
        val = value
      } else {
        if (!propToUpdate) {
          this.$refs[ref].innerText = value
          val = value
        }
      }
      if (propToUpdate) {
        propToUpdate[field] = value
      } else {
        this.discardInfo[field] = val
      }
      this.$forceUpdate()
      window.$('#popover-' + ref).popoverX('hide')
    },

    async getDiscardDetails (discardId) {
      try {
        let discard = await this.$http.post(this.$api_url.discard_detail, { discard_id: discardId })
        let $data = this.$invoiceTools.prepareResult(discard.data, 'list', 'Discard:getDiscardDetails')
        if ($data.success === true) {
          this.discardInfo = $data.data.information
          this.discardDetail = $data.data.details
        } else {
          this.$toastr.error($data.data, this.translations('common.error'))
        }
      } catch (error) {
        console.log('Discard:getDiscardDetails:catch(error): ', error)
        this.$toastr.error(this.translations('discard.notice_failed'), this.translations('common.error'))
      }
    },

    deleteDetail (i) {
      this.discardDetail.splice(i, 1)
    },

    async listPersonals () {
      try {
        let cList = await this.$http.post(this.$api_url.discard_personnel)
        let $data = this.$invoiceTools.prepareResult(cList.data, 'list', 'NewDiscard:listPersonals')
        if ($data.success === true) {
          this.destinations = $data.data
        } else {
          this.destinations = [{ id: 0, name: 'No record.' }]
          this.$toastr.error($data.data, this.translations('common.error'))
        }
      } catch (error) {
        console.log('NewDiscard:listPersonals:catch(error): ', error)
        this.$toastr.error(this.translations('discard.notice_failed'), this.translations('common.error'))
      }
    },

    getSequence () {
      return this.$http.post(this.$api_url.discard_sequence).then(response => {
        const result = response.data
        if (result.status === true) {
          this.tempInfo.discard_number = result.sequence
          this.discardInfo.discard_number = result.sequence
          this.$refs['info04'].innerText = result.sequence
          this.$refs['input-info04'].value = result.sequence
        }
      }).catch(error => {
        console.log('NewDiscard:getSequence:catch(error): ', error)
        this.$toastr.error(this.translations('discard.notice_failed'), this.translations('common.error'))
      }).finally(() => {
        return Promise.resolve()
      })
    },

    getRetrunPropsById (selection, id, name) {
      let ret = ''
      selection.forEach((val, i) => {
        if (val.id === id) {
          ret = val[name]
        }
      })
      return ret
    },

    async addDiscard () {
      if (!this.discardInfo.apply_date) {
        this.$toastr.warning(this.translations('discard.notice_apply_date'))
        return
      }

      if (!this.discardInfo.discard_date) {
        this.$toastr.warning(this.translations('discard.notice_added_date'))
        return
      }

      if (!this.discardInfo.manufacturers_id) {
        this.$toastr.warning(this.translations('discard.notice_manufacturer'))
        return
      }

      if (!this.discardInfo.warehouses_id) {
        this.$toastr.warning(this.translations('discard.notice_warehouse'))
        return
      }

      if (this.discardDetail.length < 1) {
        this.$toastr.warning(this.translations('discard.notice_enter_details_line'))
        return
      }

      this.discardInfo.apply_date = format(new Date(this.discardInfo.apply_date), "yyyy-MM-dd'T'HH:mm:ss")
      this.discardInfo.discard_date = format(new Date(this.discardInfo.discard_date), "yyyy-MM-dd'T'HH:mm:ss")

      this.$dialog.confirm(this.translations('discard.notice_confirm_save'), {
        okText: this.translations('common.yes'),
        cancelText: this.translations('common.no')
      }).then(async () => {
        try {
          this.isLoading = true
          const params = {
            information: this.discardInfo,
            details: this.discardDetail
          }
          console.log(JSON.stringify(params)) // DEBUG
          const response = await this.$http.post(this.$api_url.discard_add, params)
          const result = response.data
          if (result.status === true) {
            this.$toastr.success(this.translations('discard.notice_save_success'), this.translations('common.success'))
            this.$router.replace('archive-discard')
          } else {
            this.$toastr.error(result.message, this.translations('common.error'))
          }
          this.isLoading = false
        } catch (error) {
          this.isLoading = false
          console.log('NewDiscard:addDiscard:catch(error): ', error)
          this.$toastr.error(this.translations('discard.notice_failed'), this.translations('common.error'))
        }
      })
    },

    onchangeTaxclass () {
      this.discardDetail.forEach((detail, i) => {
        if (typeof detail !== 'undefined') {
          this.discardDetail[i] = this.prepareDetails(detail)
        }
      })
      this.calcGrandTotals()
    },

    prepareDetails (data) {
      data.total_cost = data.quantity * data.row_price
      data.total_unit_price = data.quantity * data.unit_price
      data.total_profit = data.total_unit_price - data.total_cost

      if (data.taxclass_id && Number(data.taxclass_id) === 2) { // 税区分（1:課税対象, 2:対象外）
        data.total_cost_inctax = data.total_cost
        data.total_unit_price_inctax = data.total_unit_price
        data.total_profit_inctax = data.total_profit
        this.taxIncluded = false
      } else {
        data.total_cost_inctax = this.$util.getIncludeTax(data.total_cost, data.tax_rate)
        data.total_unit_price_inctax = this.$util.getIncludeTax(data.total_unit_price, data.tax_rate)
        data.total_profit_inctax = this.$util.getIncludeTax(data.total_profit, data.tax_rate)
        this.taxIncluded = true
      }
      return data
    },

    calcGrandTotals () {
      this.grandTotalUnitPrice = 0
      this.grandTotalUnitPriceIncTax = 0
      this.grandTotalCost = 0
      this.grandTotalCostIncTax = 0
      this.grandTotalProfit = 0
      this.grandTotalProfitIncTax = 0

      this.discardDetail.forEach(v => {
        this.grandTotalUnitPrice += Number(v.total_unit_price)
        this.grandTotalCost += Number(v.total_cost)
      })

      this.grandTotalProfit = this.grandTotalUnitPrice - this.grandTotalCost

      this.grandTotalUnitPriceIncTax = this.$util.getIncludeTax(this.grandTotalUnitPrice, this.taxRate)
      this.grandTotalCostIncTax = this.$util.getIncludeTax(this.grandTotalCost, this.taxRate)
      this.grandTotalProfitIncTax = this.grandTotalUnitPriceIncTax - this.grandTotalCostIncTax
    },

    displayGrandTotal (val, valIncTax) {
      if (!this.taxIncluded) { // 税抜
        return `${Number(val).toLocaleString()} (${Number(valIncTax).toLocaleString()})`
      } else {
        return `${Number(valIncTax).toLocaleString()} (${Number(val).toLocaleString()})`
      }
    },

    onChangePrice (key, detail) {
      const taxRate = Number(detail.tax_rate || this.taxRate)
      detail[key] = detail[key].replace(/[^0-9.-]/g, '')
      if (key === 'unit_price') {
        detail.unit_price_inctax = this.$util.getIncludeTax(detail[key], taxRate)
      } else if (key === 'unit_price_inctax') {
        detail.unit_price = this.$util.getExcludeTax(detail[key], taxRate)
      }
    },

    divisionRenderText (divisonType) {
      for (let index = 0; index < this.divisionTypes.length; index++) {
        const element = this.divisionTypes[index]
        if (element.value === divisonType) {
          return element.label
        }
      }
      return '-----------'
    }
  }
}
</script>

<style scoped>
.input-date {
  width: 140px;
}
</style>
